export const domainHierarchy = Object.freeze( {
    child_domain: 'subdomains',
    org_domain: 'parent domains'
} );

const domainTypeSelector = {
    'all-domains': 'All domains',
    'nonsending-domains': 'Non-Sending Domains',
    'sending-domains': 'Sending Domains'
};

const domainTypes = {
    defensively_registered: 'Non-Sending',
    nonsending: 'Non-Sending',
    sending: 'Sending',
};

const authStatuses = {
    invalid: 'Invalid record',
    no_record: 'No record',
    valid: 'Valid'
};

const dmarcPolicies = {
    none: 'p=none',
    quarantine: 'p=quarantine',
    reject: 'p=reject',
};

const dmarcStatusPolicies = {
    invalid_record: 'Invalid record',
    p_none: 'p=none',
    p_quarantine: 'p=quarantine',
    p_reject: 'p=reject',
};

const boolToYesOrNo = {
    [false]: 'No',
    [true]: 'Yes',
};

export default Object.freeze( {
    ...authStatuses,
    ...dmarcPolicies,
    ...domainHierarchy,
    ...dmarcStatusPolicies,
    ...domainTypeSelector,
    ...domainTypes,
    ...boolToYesOrNo,
} );
